export default __webpack_public_path__ + "static/baked-treat-52009335f17d76c22591be281cc63595.png";